import React, { useState } from "react";
import { InputNumber, InputNumberProps } from "antd";

type FormattedNumberInputProps = InputNumberProps<number>;

const FormattedNumberInput: React.FC<FormattedNumberInputProps> = (props) => {
  const [focused, setFocused] = useState(false);
  return (
    <InputNumber<number>
      {...props}
      step={0.01}
      precision={2}
      formatter={(val) => {
        if (focused) return val?.toString() || "";
        if (val === undefined || val === null) return "";
        const num = Number(val);
        return num.toFixed(props.precision ?? 2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }}
      parser={(val) => {
        if (!val) return 0;
        return parseFloat(val.replace(/,/g, ""));
      }}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
    />
  );
};

export default FormattedNumberInput;
